/**
 * Listen for trainer session-pause broadcast on the LiveKit data channel.
 */

import { useEffect } from "react";
import { useMaybeRoomContext } from "@livekit/components-react";
import { RoomEvent } from "livekit-client";
import { decodeLiveSessionPaused } from "./liveSessionPauseSync";

type Args = {
  enabled?: boolean;
  onSessionPaused?: (msg: {
    message?: string;
    expected_resume_at?: string;
  }) => void;
};

export function useLiveSessionPauseSync({
  enabled = true,
  onSessionPaused,
}: Args): void {
  const room = useMaybeRoomContext();

  useEffect(() => {
    if (!enabled || !room || !onSessionPaused) return;

    const onData = (
      payload: Uint8Array,
      _participant?: unknown,
      _kind?: unknown,
      topic?: string,
    ) => {
      void topic;
      const msg = decodeLiveSessionPaused(payload);
      if (msg) {
        onSessionPaused({
          message: msg.message,
          expected_resume_at: msg.expected_resume_at,
        });
      }
    };

    room.on(RoomEvent.DataReceived, onData);
    return () => {
      room.off(RoomEvent.DataReceived, onData);
    };
  }, [enabled, room, onSessionPaused]);
}
